"use client"

import { useState } from "react"
import { MenuIcon, XIcon } from "../Icons/Icons"
import Container from "../Container/Container"
import Button from "../Button/Button"
import "./Header.css"



import { motion } from "framer-motion"
import "bootstrap-icons/font/bootstrap-icons.css";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const navItems = [
    { name: "Home", path: "#home" },
    { name: "About", path: "#about" },
    // { name: "Menu", path: "#menu" },
    { name: "Gallery", path: "#gallery" },
    { name: "Contact", path: "#contact" },
  ]

  return (
    <header className="header">
          
      <Container>
    
        <div className="header-content">
          <a href="#home" className="header-logo">
            <img src="../assets/Frame.svg" alt="Kachit Logo" className="h-8 w-auto" />


          </a>

          {/* Desktop Navigation */}
          <nav className="header-nav">
            {navItems.map((item, index) => (
              <a
                key={item.name}
                href={item.path}
                className="header-nav-link"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {item.name}
              </a>
            ))}
          </nav>

          <div className="header-actions">
           

            {/* <Button
  className="header-reserve-btn" target="_blank"
  onClick={() => window.location.href = "https://vendor.katchit.in/"}
>
  Register Vendor
</Button> */}

<a
  href="https://vendor.katchit.in/"
  target="_blank"
  rel="noopener noreferrer"
>
  <Button className="header-reserve-btn">
    Register Vendor
  </Button>
</a>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="header-mobile-toggle">
              {mobileMenuOpen ? <XIcon className="header-icon" /> : <MenuIcon className="header-icon" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`header-mobile-menu ${mobileMenuOpen ? "header-mobile-menu-open" : ""}`}>
          <nav className="header-mobile-nav">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.path}
                className="header-mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </a>
            ))}
           
<a
  href="https://vendor.katchit.in/"
  target="_blank"
  rel="noopener noreferrer"
>
  <Button className="header-reserve-btn">
    Register Vendor
  </Button>
</a>
          </nav>
        </div>
      </Container>

      <div className="banner flex justify-center items-center w-full h-full min-h-[100px]  text-white" >
      <motion.h1
        className="text-3xl md:text-2xl lg:text-1xl font-extrabold tracking-tight text-center " 
        initial={{ opacity: 0, x: -100 }}
        animate={{
          opacity: [0, 1, 1, 0], // Fade in, stay, fade out
          x: [-100, 0, 0, 100],   // Move in from left, stay, move out to right
        }}
        transition={{
          duration: 4, // Total duration for one cycle
          ease: "easeInOut",
          repeat: Infinity,
          repeatDelay: 1, // Pause before repeating
        }}
      >
🚀 Now Live in Delhi
      </motion.h1>
    </div>
    </header>
  )
}

export default Header
